import React, { useState, useContext, useRef, useEffect, useMemo } from "react";
import ParameterWindow from "./ParameterWindow";
import { DashboardContext } from "../../../context/DashboardContext";
import { GraphContext } from "../../../context/GraphContext";
import { AuthContext } from "../../../context/AuthContext";
import {
  deepCopy,
  addSubModelToModels,
  hasParentOrChildWithID,
//  getModelById,
  //setLinked,
//  replaceModelById,
  linkedSubModelAdd,
//  createModelFromParamList,
//  generateModel,
  refreshLinks,
  //updateGroupsAfterLinking,
} from "../../leftSide/Models/modelLogic";
import {
  checkIfDefaultExpanded,
  getUpdatedUniqueIds,
  isParamDescendant,
  getSubModelIdList,
} from "./parameterLogic";
import StickyParameterWindow from "./StickyParameterWindow";
import "./parameters.scss";
import {
  // arrayBufferToBase64,
  // generateWarningObject,
  getLayoutForWindows,
  getPlaceholderParamWindowPosition,
  hasProperty,
  isDeepEqual,
  offsetWindowsFromTop,
//  simpleReadFile,
  updateModelsOnGroupChanges,
  updateNestedModel,
} from "../../../utils/helpers";
import { WebSocketContext } from "../../../context/WebSocketContext";
import { GeneralContext } from "../../../context/GeneralContext";
import { useTutorialProgress } from "../../../context/TutorialContext";
import BlockingOverlay from "../../commonComponents/BlockingOverlay";

function Parameters(props) {
  const { fitOpen, fitWindowHeight } = props;
  const {
    modelData,
    setModelData,
    modelNextID,
    setModelNextID,
    abbrDic,
    setAbbrDic,
    namingDic,
    setNamingDic,
    allLocalModels,
    allLocalLineshapes,
    //valueGroups,
    setValueGroups,
    expandedWindows,
    setExpandedWindows,
   // setWarnings,
    //setNewWarningCount,
    areParamsSorted,
    paramWindowPosAndSize,
    setParamWindowPosAndSize,
    addSubModTitle,
    checkIfSubModTitle,
  } = useContext(DashboardContext);
  const {
   // lastJsonMessage,
    sendJsonMessage,
    isFitOngoing,
    isLoopOngoing,
  //  retrieveRequestData,
  //  deleteRequestDataEntry,
  } = useContext(WebSocketContext);
  const { setUpdatedModelFE_IDs } = useContext(GraphContext);
  const { currentUser } = useContext(AuthContext);
  const { recordedErrorLog } = useContext(GeneralContext);
  const { monitorStateChange } = useTutorialProgress();
  const [updateBacklog, setUpdateBacklog] = useState({});
  const [idChain, setIdChain] = useState([]);
  const [linkingActive, setLinkingActive] = useState(false);
  const [linkingID, setLinkingID] = useState(null);
  //const [linkingSpeqqleID, setLinkingSpeqqleID] = useState(null);
  const [stickyWindowOpen, setStickyWindowOpen] = useState(false);
  const [modelForStickyIndexes, setModelForStickyIndexes] = useState(null);
  const [recForSticky, setRecForSticky] = useState(null);
  const [lineshapeIdForSticky, setLineshapeIdForSticky] = useState(-1);
  const [cellForSticky, setCellForSticky] = useState(null);
  const [tableIndexForSticky, setTableIndexForSticky] = useState(null);
  const [cellColumn, setCellColumn] = useState(null);
  const [cellFeId, setCellFeId] = useState(null);
  const [localExpanded, setLocalExpanded] = useState({});
  const [needsPosRecalculation, setNeedsPosRecalculation] = useState(false);
  const [newPositionsToAdd, setNewPositionsToAdd] = useState({});
  const [needsLinkRefresh, setNeedsLinkRefresh] = useState(false);

  //This variable is needed to pass value and fix updates done directly in the table to sticky parameter window
  const [valueUpdate, setValueUpdate] = useState(null);
  const [fixedUpdate, setFixedUpdate] = useState(null);

  const modelDataRef = useRef(deepCopy(modelData));
  const parametersRef = useRef(null);
  const tempUpdatedIdsRef = useRef([]);
  const windowPosAndSizesRef = useRef(paramWindowPosAndSize);
  const windowSizeUpdateTimeout = useRef(null);
  const windowPositionUpdateTimeout = useRef(null);
  const allWinPosUpdateTimeout = useRef(null);
  // const requestedBinary = useRef(null);
  let isRendering = false;

  // Add a ref to collect pending positions during render

  useEffect(() => {
    if (areParamsSorted) {
      setNeedsPosRecalculation(true);
    }
  }, [fitWindowHeight, areParamsSorted]);

  useEffect(() => {
    if (needsPosRecalculation && areParamsSorted) {
      const updateSizeArray = () => {
        let newPositionsArray = getLayoutForWindows(
          paramWindowPosAndSize,
          window.innerWidth - 60
        );

        if (fitOpen && areParamsSorted && fitWindowHeight) {
          newPositionsArray = offsetWindowsFromTop(
            newPositionsArray,
            fitWindowHeight + 30
          );
        }

        if (!isDeepEqual(newPositionsArray, paramWindowPosAndSize)) {
          const updatedPosArrayToSet = deepCopy(newPositionsArray);
          windowPosAndSizesRef.current = updatedPosArrayToSet;
          setParamWindowPosAndSize(updatedPosArrayToSet);
          clearTimeout(allWinPosUpdateTimeout.current);
          allWinPosUpdateTimeout.current = null;
        }
      };
      clearTimeout(allWinPosUpdateTimeout.current);
      allWinPosUpdateTimeout.current = setTimeout(updateSizeArray, 100);

      setNeedsPosRecalculation(false);
    }
  }, [
    needsPosRecalculation,
    areParamsSorted,
    paramWindowPosAndSize,
    fitWindowHeight,
  ]);

  useEffect(() => {
    if (areParamsSorted) {
      setNeedsPosRecalculation(true);
    }
  }, [fitOpen, areParamsSorted]);

  useEffect(() => {
    if (paramWindowPosAndSize && windowPosAndSizesRef.current) {
      const globalStateKeys = Object.keys(paramWindowPosAndSize);
      const refKeys = Object.keys(windowPosAndSizesRef.current);
      if (!isDeepEqual(globalStateKeys, refKeys)) {
        for (let i = 0; i < refKeys.length; i++) {
          const refKey = refKeys[i];

          if (!hasProperty(globalStateKeys, refKey)) {
            delete windowPosAndSizesRef.current[refKey];
          }
        }
      }
    }
  }, [paramWindowPosAndSize]);

  useEffect(() => {
    if (areParamsSorted) {
      setNeedsPosRecalculation(true);
    }
  }, [areParamsSorted]);

  useEffect(() => {
    const updatedPositions = { ...paramWindowPosAndSize, ...newPositionsToAdd };
    windowPosAndSizesRef.current = deepCopy(updatedPositions);
    setParamWindowPosAndSize(updatedPositions);
    setNeedsPosRecalculation(true);
  }, [newPositionsToAdd]);

  function updateOnWindowSizeChange(modelId, size) {
    try {
      if (
        hasProperty(windowPosAndSizesRef.current, modelId) &&
        (!hasProperty(windowPosAndSizesRef.current[modelId], "size") ||
          !isDeepEqual(windowPosAndSizesRef.current[modelId].size, size))
      ) {
        windowPosAndSizesRef.current[modelId].size = size;
        const updateSizeArray = () => {
          setParamWindowPosAndSize(deepCopy(windowPosAndSizesRef.current));
          clearTimeout(windowSizeUpdateTimeout.current);
          windowSizeUpdateTimeout.current = null;
          setNeedsPosRecalculation(true);
        };
        clearTimeout(windowSizeUpdateTimeout.current);
        windowSizeUpdateTimeout.current = setTimeout(updateSizeArray, 50);
      }
    } catch (error) {
      recordedErrorLog("Error updating parameter window size: ", error);
    }
  }

  function updateOnWindowPositionChange(modelId, position) {
    try {
      if (
        hasProperty(windowPosAndSizesRef.current, modelId) &&
        (!hasProperty(windowPosAndSizesRef.current[modelId], "position") ||
          !isDeepEqual(
            windowPosAndSizesRef.current[modelId].position,
            position
          ))
      ) {
        windowPosAndSizesRef.current[modelId].position = position;
        const updatePositionArray = () => {
          setParamWindowPosAndSize(windowPosAndSizesRef.current);
          clearTimeout(windowPositionUpdateTimeout.current);
          windowPositionUpdateTimeout.current = null;
          setNeedsPosRecalculation(true);
        };
        clearTimeout(windowPositionUpdateTimeout.current);
        windowPositionUpdateTimeout.current = setTimeout(
          updatePositionArray,
          100
        );
      }
    } catch (error) {
      recordedErrorLog("Error updating parameter window size: ", error);
    }
  }

  // function generateModelForParams(speqqleID) {
  //   const generatedModel = generateModel(
  //     addSubModTitle,
  //     speqqleID,
  //     getID,
  //     upID,
  //     getAbbrDic,
  //     setLocalAbbrDic,
  //     // allModels,
  //     allLocalModels,
  //     namingDic,
  //     setNamingDic,
  //     false,
  //     recordedErrorLog,
  //     allLocalLineshapes,
  //     currentUser,
  //     sendJsonMessage,
  //     false
  //   );

  //   return generatedModel;
  // }

  // function handleBinaryLoad(jsonMessage) {
  //   try {
  //     const modelFromBinary = jsonMessage.Model.SendModel[0];

  //     const modelsCopy = deepCopy(modelData);
  //     const modelToUpdate = getModelById(modelFromBinary.modelid, modelsCopy);
  //     const filledModelWithParams = createModelFromParamList(
  //       modelFromBinary,
  //       modelToUpdate,
  //       generateModelForParams,
  //       sendJsonMessage,
  //       currentUser,
  //       allLocalLineshapes
  //     );

  //     const updatedWithNew = replaceModelById(
  //       modelsCopy,
  //       filledModelWithParams,
  //       modelFromBinary.modelid
  //     );

  //     setModelData(updatedWithNew);
  //     setUpdatedModelFE_IDs([modelFromBinary.modelid]);
  //   } catch (error) {
  //     recordedErrorLog(
  //       "Failed to handle binary file load in parameter window: ",
  //       error
  //     );
  //   }
  // }

  useEffect(() => {
    if (needsLinkRefresh) {
      // Use modelDataRef to get the latest modelData, which includes any pending changes from changeModel
      const modelDataCopy = deepCopy(modelDataRef.current);
      refreshLinks(modelDataCopy);
      modelDataRef.current = modelDataCopy;
      setModelData(modelDataCopy);
      setNeedsLinkRefresh(false);
    }
  }, [needsLinkRefresh, modelData]);

  // useEffect(() => {
  //   try {
  //     if (lastJsonMessage) {
  //       if (hasProperty(lastJsonMessage, "requestID")) {
  //         const requestData = retrieveRequestData(lastJsonMessage.requestID);
  //         if (requestData !== null) {
  //           switch (requestData.type) {
  //             case "binary-load-parameter-window":
  //               handleBinaryLoad(lastJsonMessage);
  //               deleteRequestDataEntry(lastJsonMessage.requestID);
  //               break;
  //             default:
  //               break;
  //           }
  //         }
  //       } else {
  //         throw new Error("Request ID was not attached to the json message.");
  //       }
  //     }
  //   } catch (error) {
  //     recordedErrorLog(
  //       "Last Json message handling failure in useEffect: ",
  //       error
  //     );
  //   }
  // }, [lastJsonMessage]);


  // Helper function to check tutorial parameter conditions
  const checkTutorialParameterConditions = (updatedModel) => {
    try {
      if (
        updatedModel === null ||
        updatedModel === undefined ||
        !hasProperty(updatedModel, "speqqleID")
      ) {
        return;
      }
      monitorStateChange("model_updated_in_parameters", {
        model: updatedModel,
      });
    } catch (error) {
      recordedErrorLog("Tutorial parameter check failure: ", error);
    }
  };

  // We have local expansion dictionary because if we try to update Context while Parameters component is being
  // rendered, we get an error. With this we record the changes locally and only when component is redered, we
  // propagate them to the Context
  useEffect(() => {
    setExpandedWindows(localExpanded);
  }, [localExpanded]);

  useEffect(() => {
    if (!isDeepEqual(modelDataRef.current, modelData)) {
      modelDataRef.current = deepCopy(modelData);
      setNeedsPosRecalculation(true);
    }
  }, [modelData]);

  const changeModel = (
    updatedModel,
    FE_ID,
    valGroups = null,
    fromFile = false
  ) => {
    try {
      if (isRendering) {
        if (hasProperty(updateBacklog, FE_ID)) {
          setUpdateBacklog({
            ...updateBacklog,
            [FE_ID]: { ...updateBacklog[FE_ID], ...updatedModel },
          });
        } else {
          setUpdateBacklog({ ...updateBacklog, [FE_ID]: updatedModel });
        }
      } else {
        if (valGroups != null) {
          const oldModelData = deepCopy(modelDataRef.current);
          const newModelData = updateNestedModel(
            oldModelData,
            updatedModel,
            FE_ID
          );
          // const updatedModelWithGroups = handleValueGroupChanges(
          //   newModelData,
          //   valGroups
          // );
          const updatedModelWithGroups = updateModelsOnGroupChanges(
            newModelData,
            valGroups
          );
          tempUpdatedIdsRef.current = [
            ...tempUpdatedIdsRef.current,
            ...updatedModelWithGroups.updatedIds,
          ];

          if (fromFile) {
            // When loading from file, recursively add all submodel FE_IDs as well
            const allModelIds = getSubModelIdList(updatedModel);
            tempUpdatedIdsRef.current = [
              ...tempUpdatedIdsRef.current,
              ...allModelIds,
            ];
          }

          setValueGroups(valGroups);
          if (
            !isDeepEqual(oldModelData, updatedModelWithGroups.udpatedModels)
          ) {
            setUpdatedModelFE_IDs((oldIDS) => {
              const uniqueIds = getUpdatedUniqueIds(
                [...oldIDS, ...tempUpdatedIdsRef.current],
                modelDataRef.current
              );

              return uniqueIds;
            });
            modelDataRef.current = updatedModelWithGroups.udpatedModels;
            if (fromFile) {
              refreshLinks(modelDataRef.current);
            }
            setModelData(modelDataRef.current);

            // Check tutorial parameter conditions after successful model update
            checkTutorialParameterConditions(updatedModel);

            tempUpdatedIdsRef.current = [];
            return modelDataRef.current;
          }
        } else {
          const oldModelData = deepCopy(modelDataRef.current);
          const newModelData = updateNestedModel(
            oldModelData,
            updatedModel,
            FE_ID
          );
          let allModelIds = [FE_ID];
          if (fromFile) {
            allModelIds = [...allModelIds, ...getSubModelIdList(updatedModel)];
          }
          if (!isDeepEqual(oldModelData, newModelData)) {
            setUpdatedModelFE_IDs((oldIDS) => {
              const uniqueIds = getUpdatedUniqueIds(
                [...oldIDS, ...allModelIds],
                modelDataRef.current
              );
              return uniqueIds;
            });
            modelDataRef.current = newModelData;
            if (fromFile) {
              refreshLinks(modelDataRef.current);
            }

            setModelData(() => {
              return modelDataRef.current;
            });

            // Check tutorial parameter conditions after successful model update
            checkTutorialParameterConditions(updatedModel);

            tempUpdatedIdsRef.current = [];
            return modelDataRef.current;
          }
          // setModelData((prevModelData) => {
          //   const newModelData = updateNestedModel(
          //     prevModelData,
          //     updatedModel,
          //     FE_ID
          //   );
          //   return newModelData;
          // });
        }
      }
      tempUpdatedIdsRef.current = [];
    } catch (error) {
      recordedErrorLog("Model change has failed: ", error);
    }
  };

  const currentID = useRef(modelNextID);

  useEffect(() => {
    if (currentID.current !== modelNextID) {
      currentID.current = modelNextID;
    }
  }, [modelNextID]);

  function getID() {
    return currentID.current;
  }

  function upID() {
    currentID.current = currentID.current + 1;
    setModelNextID(currentID.current);
  }

  const localAbbrDic = useRef(abbrDic);

  useEffect(() => {
    if (!isDeepEqual(abbrDic, localAbbrDic.current)) {
      localAbbrDic.current = abbrDic;
    }
  }, [abbrDic]);

  function getAbbrDic() {
    return localAbbrDic.current;
  }

  function setLocalAbbrDic(changedAbbrs) {
    localAbbrDic.current = changedAbbrs;
    setAbbrDic(localAbbrDic.current);
  }

  function getModelByIndexes(models, indexes) {
    try {
      const [currentIndex, ...restIndexes] = indexes;
      return restIndexes.length === 0
        ? models[currentIndex]
        : getModelByIndexes(models[currentIndex].subModels, restIndexes);
    } catch (error) {
      recordedErrorLog("Get model by indexes failure: ", error);
    }
  }

  function addSubModelFromParams(FE_ID, linked, indexes, indexToInsert) {
    try {
      let newList;
      if (linked) {
        newList = linkedSubModelAdd(
          addSubModTitle,
          modelData,
          FE_ID,
          getID,
          allLocalModels,
          upID,
          getAbbrDic,
          setLocalAbbrDic,
          namingDic,
          setNamingDic,
          recordedErrorLog,
          indexToInsert,
          allLocalLineshapes,
          currentUser,
          sendJsonMessage
        );
      } else {
        newList = addSubModelToModels(
          addSubModTitle,
          modelData,
          FE_ID,
          getID,
          allLocalModels,
          upID,
          getAbbrDic,
          setLocalAbbrDic,
          namingDic,
          setNamingDic,
          null,
          recordedErrorLog,
          indexToInsert,
          allLocalLineshapes,
          currentUser,
          sendJsonMessage
        );
      }

      setModelData(newList);
      return getModelByIndexes(newList, indexes);
    } catch (error) {
      recordedErrorLog("Sub model from params addition failure: ", error);
    }
  }

  // const handleBinaryModelLoad = async (ID, fileData) => {
  //   try {
  //     // We select just the first entry here, because you can only open a single file from parameter window
  //     const rfmData = await simpleReadFile(fileData[0]);

  //     const sendModel = [];

  //     // Handle RFM file processing logic here
  //     const base64Content = arrayBufferToBase64(rfmData.content);
  //     // requestedBinary.current = ID;
  //     sendModel.push({
  //       modelid: ID,
  //       binary: base64Content,
  //     });

  //     const payload = {
  //       User: currentUser.id,
  //       Model: {
  //         SendModel: sendModel,
  //       },
  //     };

  //     sendJsonMessage(payload, {
  //       type: "binary-load-parameter-window",
  //     });
  //   } catch (error) {
  //     recordedErrorLog("ERROR RFM FILE PROCESS: ", error);
  //     limitedToast("Selected RFM file could not be processed.");
  //     generateWarningObject(
  //       "Selected RFM file could not be processed.",
  //       2,
  //       setWarnings,
  //       setNewWarningCount
  //     );
  //   }
  // };

  const renderModels = (modelData, changeModel, addSubModelFromParams) => {
    try {
      const expanded = deepCopy(expandedWindows);

      let positionIndex = 0;
      let hadUnclearPos = false;
      let placeholderPosSizeDict = {};

      const renderModelsRecursive = (
        models,
        expanded,
        changeModel,
        addSubModelFromParams,
        indexes = [],
        renderedFEIDs = new Set()
      ) => {
        return models.flatMap((model, index) => {
          const modelToRender = deepCopy(model);
          if (renderedFEIDs.has(modelToRender.FE_ID)) {
            return [];
          }

          renderedFEIDs.add(modelToRender.FE_ID);
          const currentIndexes = [...indexes, index];

          const betterKey = `${modelToRender.displayName}|${
            modelToRender.FE_ID
          }|${currentIndexes.join("-")}`;

          const defaultExpanded = checkIfDefaultExpanded(
            expanded,
            modelToRender.FE_ID
          );

          let initialPos = { x: 1000, y: 0 };
          let isNew = false;

          if (
            windowPosAndSizesRef.current &&
            typeof windowPosAndSizesRef.current === "object" &&
            hasProperty(windowPosAndSizesRef.current, modelToRender.FE_ID)
          ) {
            initialPos =
              windowPosAndSizesRef.current[modelToRender.FE_ID].position;
          } else if (
            paramWindowPosAndSize &&
            typeof paramWindowPosAndSize === "object" &&
            hasProperty(paramWindowPosAndSize, modelToRender.FE_ID) &&
            hasProperty(paramWindowPosAndSize[modelToRender.FE_ID], "position")
          ) {
            initialPos = paramWindowPosAndSize[modelToRender.FE_ID].position;
          } else {
            isNew = true;
            initialPos = areParamsSorted
              ? getPlaceholderParamWindowPosition(positionIndex)
              : { x: (window.innerWidth / 3) * 2, y: window.innerHeight / 4 };
            // Instead of placeholderPosSizeDict, collect in ref
            //pendingPositionsRef.current[modelToRender.FE_ID] = {
            //  position: initialPos,
            //  size: { width: 200, height: 200 },
            //};
            placeholderPosSizeDict[modelToRender.FE_ID] = {};
            placeholderPosSizeDict[modelToRender.FE_ID].position = initialPos;
            placeholderPosSizeDict[modelToRender.FE_ID].size = {
              width: 200,
              height: 200,
            };
            hadUnclearPos = true;
          }

          positionIndex++;

          return [
            <React.Fragment key={betterKey}>
              <ParameterWindow
                key={betterKey}
                model={modelToRender}
                modelIndex={currentIndexes}
                changeModel={changeModel}
                addSubModelFromParams={addSubModelFromParams}
                handleModelClick={handleModelClick}
                //startLinking={startLinking}
                canLink={canLink}
                isLinkActive={isLinkActive}
                openParameterWindow={openParameterWindow}
                idChain={idChain}
                setValueUpdate={setValueUpdate}
                setFixedUpdate={setFixedUpdate}
                defaultExpanded={defaultExpanded}
                changeExpansion={changeExpansion}
//                loadBinary={handleBinaryModelLoad}
                initialPosition={initialPos}
                updateOnWindowSizeChange={updateOnWindowSizeChange}
                updateOnWindowPositionChange={updateOnWindowPositionChange}
                needsLinkRefresh={() => setNeedsLinkRefresh(true)}
                isNew={isNew}
              />
            </React.Fragment>,
            ...(Array.isArray(modelToRender.subModels) &&
            modelToRender.subModels.length > 0
              ? renderModelsRecursive(
                  modelToRender.subModels,
                  expanded,
                  changeModel,
                  addSubModelFromParams,
                  currentIndexes,
                  renderedFEIDs
                )
              : []),
          ];
        });
      };

      isRendering = true;
      const renderedWindows = renderModelsRecursive(
        modelData,
        expanded,
        changeModel,
        addSubModelFromParams
      );
      isRendering = false;
      if (hadUnclearPos) {
        setNewPositionsToAdd(deepCopy(placeholderPosSizeDict));
      }
      handleChangesAfterRender(); // Remove this from render phase
      setLocalExpanded(expanded);

      return renderedWindows;
    } catch (error) {
      recordedErrorLog("Model rendering has failed: ", error);
    }
  };

  function changeExpansion(id, status) {
    try {
      const expandedUpdate = deepCopy(expandedWindows);

      expandedUpdate[id] = status;

      setExpandedWindows(expandedUpdate);
    } catch (error) {
      recordedErrorLog("Expansion change has failed: ", error);
    }
  }

  function handleChangesAfterRender() {
    try {
      const backlogKeys = Object.keys(updateBacklog);

      if (backlogKeys.length > 0) {
        let copyOfModelData = deepCopy(modelData);

        for (let i = 0; i < backlogKeys.length; i++) {
          const updateKey = backlogKeys[i];

          copyOfModelData = updateNestedModel(
            copyOfModelData,
            updateBacklog[updateKey].updatedModel,
            updateBacklog[updateKey].FE_ID
          );
        }

        setModelData(copyOfModelData);
      }
    } catch (error) {
      recordedErrorLog("Changes after render handler failure: ", error);
    }
  }

  function findRelatedFE_IDs(arr, targetFE_ID) {
    const result = new Set();

    function traverse(obj) {
      try {
        if (obj.FE_ID === targetFE_ID) {
          result.add(obj.FE_ID);
          addParentsAndSiblings(obj);
          addDescendants(obj);
        } else {
          obj.subModels.forEach(traverse);
        }
      } catch (error) {
        recordedErrorLog("Traversing has failed: ", error);
      }
    }

    function addParentsAndSiblings(obj) {
      try {
        if (!obj.parent) return;
        result.add(obj.parent.FE_ID);
        obj.parent.subModels.forEach((subModel) => {
          result.add(subModel.FE_ID);
        });
        addParentsAndSiblings(obj.parent);
      } catch (error) {
        recordedErrorLog("Adding parents and siblings has failed: ", error);
      }
    }

    function addDescendants(obj) {
      try {
        obj.subModels.forEach((subModel) => {
          result.add(subModel.FE_ID);
          addDescendants(subModel);
        });
      } catch (error) {
        recordedErrorLog("Adding descendants has failed: ", error);
      }
    }

    function addParentReferences(arr, parent = null) {
      try {
        arr.forEach((obj) => {
          obj.parent = parent;
          addParentReferences(obj.subModels, obj);
        });
      } catch (error) {
        recordedErrorLog("Adding Parent references has failed: ", error);
      }
    }

    try {
      addParentReferences(arr);
      arr.forEach(traverse);

      return Array.from(result);
    } catch (error) {
      recordedErrorLog("Related FE_IDs finder has failed: ", error);
    }
  }

  function handleModelClick(FE_ID) {
    try {
      const ids = findRelatedFE_IDs(deepCopy(modelData), FE_ID);
      setIdChain(ids);
    } catch (error) {
      recordedErrorLog("Model Click handler failure: ", error);
    }
  }

  function canLink(ID, speqqleID) {
    try {
      if (
        hasParentOrChildWithID(modelData, linkingID, speqqleID, ID) ||
        linkingID == ID //||
        //speqqleID != linkingSpeqqleID
      ) {
        return false;
      } else {
        return true;
      }
    } catch (error) {
      recordedErrorLog("canLink has failed: ", error);
    }
  }

  function isLinkActive() {
    return linkingActive;
  }

  const getModel = useMemo(() => {
    return (indexes) => {
      return getModelByIndexes(modelData, indexes);
    };
  }, [modelData]);

  function openParameterWindow(
    cell,
    rec,
    modelIndex,
    FE_ID,
    tableIndex,
    isCheckBox,
    lineshape_id
  ) {
    try {
      if (!checkIfSubModTitle(cell.column.id) && !isCheckBox) {
        //TODO: CHANGE NR
        if (
          (cellColumn != null && cellFeId != null) ||
          (cellColumn != cell.column.id && cellFeId != FE_ID)
        ) {
          setModelForStickyIndexes(modelIndex);
          setCellFeId(FE_ID);
          setCellColumn(cell.column.id);
          setCellForSticky(cell);
          setTableIndexForSticky(tableIndex);
          setRecForSticky(rec);
          setLineshapeIdForSticky(lineshape_id);
          setStickyWindowOpen(true);
        }
      }
    } catch (error) {
      recordedErrorLog("Parameter window opening has failed: ", error);
    }
  }

  useEffect(() => {
    function handleMouseDownOutside(event) {
      if (parametersRef.current && !isParamDescendant(event.target)) {
        setLinkingActive(false);
        setLinkingID(null);
      }
    }

    document.addEventListener("mousedown", handleMouseDownOutside);

    return () => {
      document.removeEventListener("mousedown", handleMouseDownOutside);
    };
  }, [parametersRef]);

  const closeStickyWindow = () => {
    setStickyWindowOpen(false);
    setModelForStickyIndexes(null);
    setCellForSticky(null);
    setRecForSticky(null);
    setLineshapeIdForSticky(-1);
  };

  const renderedModels = useMemo(() => {
    if (
      modelData != null &&
      modelData.length > 0 &&
      changeModel != undefined &&
      addSubModelFromParams != undefined
    ) {
      return renderModels(modelData, changeModel, addSubModelFromParams);
    }
    return null;
  }, [modelData, idChain, linkingActive]);

  return (
    <div
      className="parametersContainer"
      ref={parametersRef}
      id="model-parameter-window-container"
      style={isFitOngoing || isLoopOngoing ? {} : {}}
    >
      {renderedModels}
      {stickyWindowOpen ? (
        <StickyParameterWindow
          modelIndexes={modelForStickyIndexes}
          getModel={getModel}
          cell={cellForSticky}
          rec={recForSticky}
          lineshape_id={lineshapeIdForSticky}
          tableIndex={tableIndexForSticky}
          changeModel={changeModel}
          closeStickyWindow={closeStickyWindow}
          valueUpdate={valueUpdate}
          setValueUpdate={setValueUpdate}
          fixedUpdate={fixedUpdate}
          setFixedUpdate={setFixedUpdate}
          fitOpen={fitOpen}
        />
      ) : (
        <></>
      )}
      {isFitOngoing || isLoopOngoing ? (
        <BlockingOverlay />
      ) : (
        // <FitLoaderComponent text={"Fit is being processed. Please wait."} />
        <></>
      )}
    </div>
  );
}

export default Parameters;
